import { Skeleton, type Theme, styled, useTheme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';

export const SkeletonContainer = styled('div')(({ theme }) => ({
  borderRadius: theme.spacing(0.5),
  display: 'flex',
  flexDirection: 'column',
}));

export const CertsAndRatingsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1.5),
  marginTop: theme.spacing(1.5),
}));

export const RatingsContainer = styled('div')(() => ({
  display: 'flex',
}));

export type DetailsHeaderSkeletonProps = {
  compact?: boolean;
  sx?: SystemStyleObject<Theme>;
};

export const DetailsHeaderSkeleton = ({ compact, sx }: DetailsHeaderSkeletonProps) => {
  const theme = useTheme();
  const iconSize = compact ? 40 : 60;

  return (
    <SkeletonContainer sx={sx}>
      <Skeleton
        height={compact ? 30 : 36}
        sx={{ marginBottom: theme.spacing(0.5), width: '50%' }}
        variant="rectangular"
      />
      <Skeleton
        height={compact ? 24 : 28}
        sx={{ marginBottom: theme.spacing(0.5), width: '67%' }}
        variant="rectangular"
      />
      <Skeleton sx={{ fontSize: theme.typography.body2, width: '40%' }} variant="text" />
      <CertsAndRatingsContainer>
        <Skeleton height={iconSize} sx={{ alignSelf: 'flex-start' }} variant="rectangular" width={iconSize} />
        <RatingsContainer>
          <Skeleton height={iconSize} variant="rectangular" width={iconSize} />
          <Skeleton
            height={iconSize}
            sx={{ marginLeft: compact ? theme.spacing(1) : theme.spacing(2) }}
            variant="rectangular"
            width={iconSize}
          />
        </RatingsContainer>
      </CertsAndRatingsContainer>
    </SkeletonContainer>
  );
};
